import React from 'react';
import './common.scss';

const IDVHeader=({ title, subHeading, info })=>{
  return (
    <div className="row idv-header-wrapper">
      <div className="col-xs-12 col-lg-12 col-md-12">
        {
          title?<h3 className="header-font standard-blue select-delivery">{title}</h3>:null
        }
        {
          subHeading?<p>{subHeading}</p>:null
        }
        {
          info?<p>{info}</p>:null
        }
      </div>
    </div>
  );
};

export default IDVHeader;
